import _forEach from 'lodash-es/forEach';
import _isString from 'lodash-es/isString';
import _startsWith from 'lodash-es/startsWith';
import _trimStart from 'lodash-es/trimStart';

import {Directive, ElementRef, Input, Renderer2} from '@angular/core';
import {RightsService} from '../../app/shared/services/rights/rights.service';

@Directive({
    selector: '[permission]'
})
export class PermissionDirective {
    public permissionDisplay: any;

    @Input('permission')
    public permissionString: any = "default";

    constructor(
        private el: ElementRef,
        private rights: RightsService,
        private renderer: Renderer2
    ) {
        this.permissionDisplay = rights.display;
    }

    public ngOnInit(): void {
        //Test : if is string|array
        if( _isString( this.permissionString ) ){
            this.permissionString = [this.permissionString];
        }

        let view = true;

        _forEach( this.permissionString, (perm: string)=>{
            if( !this.isTrueOrFalse(perm) ){
                view = false
            }
        } );
        this.toggleVisibity( view );
    }

    /**
     * isTrueOrFalse
     *
     * @param {string} perm : permission string
     * @returns {boolean}
     */
    public isTrueOrFalse(perm: string): boolean{
        let output: boolean;
        // should the perm is true or false ? find '!' in start of string
        let boolToFind: boolean= true;
        if( _startsWith(perm, '!') ){
            boolToFind= false;
        }
        perm = _trimStart(perm, '!');

        const permissionData = this.rights.getPermission(this.permissionDisplay.root + '.' + perm);

        output = permissionData === boolToFind;
        return output;

    }


    /**
     * show/hide element if permission is true/false
     * @isPermission : boolean
     */
    public toggleVisibity(isPermission: boolean): void {
        if (!isPermission) {
            this.detachView(this.el.nativeElement);
        }
    }

    private detachView(viewRootNodes: any): void{
        for(let i = 0; i <viewRootNodes.length; i++) {
            const node = viewRootNodes[i];
            const parentElement = this.renderer.parentNode(node);
            this.renderer.removeChild(parentElement, node); }
    }

}
